import React from "react";
import ReactDOM from "react-dom";
import "./css/reset.css";
import "./css/index.css";
import App from "./components/App";
import registerServiceWorker from "./registerServiceWorker";

// import DataMulch from "./DataMulch";
// new DataMulch();

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js